import $ from 'jquery'
import { toolkitUrls } from '@/links'
import { defaultMemoryCache, ajaxCacheWrapper } from './cache'

export { getGeneratedAssessments, getGenerateAccess, deleteGeneratedAssessment }

// Always refetches, unlike the cached reads around it. Two reasons. The list is
// mutable by the very person looking at it -- generating adds a row (M4), deleting
// removes one (M5) -- so a five minute cached copy would show a teacher a stale page
// immediately after they changed it. And the response is gated on folder membership,
// which can be revoked, so serving a cached body would keep answering after access
// ended; the design turns on nothing caching an authorization decision.
// `refetch` unsets the key before fetching, so the entry is refreshed, not bypassed.
function getGeneratedAssessments(savedPageUuid) {
  let url = `${toolkitUrls.api}/saved_pages/${savedPageUuid}/generated_assessments`

  return ajaxCacheWrapper(defaultMemoryCache, {
    url,
    method: 'GET',
    dataType: 'json',
    xhrFields: { withCredentials: true }
  }, { refetch: true })
}

// Uncached for the same reason as the list above, plus one of its own: this IS an
// authorization decision, and folder edit permission can be revoked mid-session.
//
// Asked once per page rather than once per target. `decide_generate` validates the
// target_type/target_level pair for shape and then answers from the page alone
// (owner, or edit_document on the folder), so every target on a page gets the same
// answer -- one call per target would be N identical round trips. `goal` is passed
// because the pair must still be well formed to get past that validation.
function getGenerateAccess(savedPageUuid) {
  let url = `${toolkitUrls.api}/saved_pages/${savedPageUuid}/generate_access?target_type=goal`

  return ajaxCacheWrapper(defaultMemoryCache, {
    url,
    method: 'GET',
    dataType: 'json',
    xhrFields: { withCredentials: true }
  }, { refetch: true })
}

// Not wrapped in the cache at all, unlike the two reads above: there is no response body
// worth keeping, and a write has nothing to serve from a cache. Bare `$.ajax` with
// credentials matches the other library-side deletes (api/library.js).
//
// The endpoint answers 404 for *not permitted* as well as for *missing*, deliberately, so
// the two are indistinguishable to this caller. Nothing here tries to tell them apart --
// the rejection is handed on as one failure, and the caller decides what to say about it.
function deleteGeneratedAssessment(uuid) {
  return $.ajax({
    url: `${toolkitUrls.api}/generated_assessments/${uuid}`,
    method: 'DELETE',
    xhrFields: { withCredentials: true }
  })
}
